import React from 'react';
import lax from 'lax.js';
import OwlCarousel from 'react-owl-carousel3';
import OrganizadoresCongreso from '../LaxButton/OrganizadoresCongreso';

const options = {
    loop: false,
    nav: false,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    navText: [
        "<i class='icofont-rounded-left'></i>",
        "<i class='icofont-rounded-right'></i>"
    ],
    responsive: {
        0: {
            items:2,
        },
        400: {
            items:3,
        },
        576: {
            items:3,
        },
        768: {
            items:4,
        },
        1200: {
            items:5,
        }
    }
}
 
class Organizadores extends React.Component {

    constructor(props) {
        super(props)
        lax.setup()
    
        document.addEventListener('scroll', function(x) {
            lax.update(window.scrollY)
        }, false)
    
        lax.update(window.scrollY)
    }

    render(){
        return (
            <section className="partner-area ptb-120">
                <div className="container">
                    
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="partner-title platinum-sponsor">
                                <OrganizadoresCongreso />
                            </div>
                        </div>
                        <OwlCarousel 
                                className="platinum-partner-slides owl-carousel owl-theme"
                                {...options}
                            >
                                
                                <div className="col-lg-12 col-md-12">
                                </div>

                                <div className="col-lg-12 col-md-12">
                                    <div className="organizadores">
                                        <img src={require("../../assets/images/logos/fundacion-tiempos-mas-nuevos.jpg")} alt="organizador" />
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12">
                                    <div className="organizadores">
                                        <img src={require("../../assets/images/logos/colegio-monte-tabor.jpg")} alt="organizador" />
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12">
                                    <div className="organizadores">
                                        <img src={require("../../assets/images/logos/fundacion-pentecostes.jpg")} alt="organizador" />
                                    </div>
                                </div>


                            </OwlCarousel>

                        
                    </div>
                </div>
            </section>
        );
    }
}
 
export default Organizadores;